<template>
    <div>
        <van-search placeholder="请输入搜索关键词" v-model="value" :background="value ? 'white' : 'transparent'" shape="round"
                    style="width: 100%; position: absolute; top: 0; left: 0; right: 0; z-index: 10" @input="search"/>
        <div v-if="value" style="width: 100%; padding-top: 54px;" @click="value = ''">
            <div v-for="(item,index) in searchList" :key="index" @click="gotoArticleDetail(item)"
                 style="background-color: white; padding: 10px; color: #111111; margin-top: 1px; font-size: 14px;">
                {{item.newsTitle}}
            </div>
        </div>
        <div v-else class="discoverContent">
            <div style="width: 100%;">
                <van-swipe :autoplay="4000" indicator-color="white" style="width: 100%; height: 160px;">
                    <van-swipe-item v-for="(item,index) in images" :key="index">
                        <van-image :src="item.imageUrl" width="100%" height="100%"/>
                    </van-swipe-item>
                </van-swipe>
<!--                <div style="padding: 0 20px;">
                    <div style="width: 100%; display: flex; align-items: center; margin: 15px 0;">
                        <div style="width: 40px;margin-right: 10px; font-style: italic; font-weight: bold; color: #1C7CF8;">
                            积分领取
                        </div>
                        <van-swipe :autoplay="5000" :duration="600" vertical :show-indicators="false"
                                   style="height: 40px; flex:1;">
                            <van-swipe-item v-for="item in hots" :key="item.newId" @click="gotoArticleDetail(item)">
                                <div style="display: flex; align-items: center; justify-content: space-between;">
                                    <div style="font-size: 14px; display: flex; flex-direction: column; align-items: start; flex: 1;">
                                        <span :style="'color: #4E4E4E; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; max-width:'+ width+'px;'">{{item.newsTitle}}</span>
                                        <span :style="'margin-top: 2px; color: #999999; font-size: 12px; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; max-width:'+ width +'px;'">{{item.abstracts || item.createTime}}</span>
                                    </div>
                                    <van-button type="info" round
                                                style="background-color: #1C7CF8; font-size: 14px; height: 28px; line-height: 28px;"
                                                @click="gotoArticleDetail(item)">立即查看
                                    </van-button>
                                </div>
                            </van-swipe-item>
                        </van-swipe>
                    </div>
                </div>-->

            </div>
            <div class="line">
                <van-tabs v-model="active" swipeable animated color="#066BEE" line-height="2px"
                          @change="getAritcleList()">
                    <van-tab v-for="item in list" :key="item.type" :title="item.title">
                        <van-list v-model="item.loading" :finished="item.finished" finished-text="没有更多了"
                                  @load="getAritcleList()">
                            <div v-for="(subItem,index) in item.list" :key="index"
                                 style="display: flex; justify-content: space-between; border-bottom: 1px #EFEFEF solid; padding: 10px 0;"
                                 @click="gotoArticleDetail(subItem)">
                                <div style="flex: 1; margin-left: 20px; display: flex; flex-direction: column; align-items: start;">
                                    <div style="color: #333333; font: 14px bold;">{{subItem.newsTitle}}</div>
                                    <div style="color: #999999; font-size: 12px; margin-top: 6px;">
                                        {{subItem.newsDate|dateFormat('YYYY年M月D日')}}
                                    </div>
                                </div>
                                <van-image :src="subItem.newsImage" radius="6px" width="92px" height="56"
                                           style="margin: 0 20px 0 15px;"/>
                            </div>
                        </van-list>
                    </van-tab>
                </van-tabs>
            </div>
            <!--            <div class="line">-->
            <!--                <div style="display: flex; flex-direction: column; align-items: center; padding: 17px 0;">-->
            <!--                    <div style="display: flex; align-items: center;">-->
            <!--                        <img src="@/assets/yibao-logo.png" width="18px" height="18px">-->
            <!--                        <span style="margin-left: 2px; font-size: 14px; font-weight: bolder; color: #4E4E4E;">益宝·心智宝心智障者专项保险</span>-->
            <!--                    </div>-->
            <!--                    <div style="font: 10px normal; color: #999999;">益宝保险经济有限公司·益宝计划</div>-->
            <!--                </div>-->
            <!--            </div>-->
        </div>
    </div>
</template>

<script>

    import Vue from 'vue';
    import {Swipe, SwipeItem, Tab, Tabs, List, Cell, Icon, Image, Search} from 'vant';
    import Cookies from 'js-cookie'

    Vue.use(Swipe).use(SwipeItem).use(Tab).use(Tabs).use(List).use(Cell).use(Icon).use(Image).use(Search);

    export default {
        name: 'Discover',
        components: {},
        data() {
            return {
                value: '',
                width: window.outerWidth - 190,
                type: Cookies.get('type'),
                active: 0,
                current: 0,
                images: [],
                hots: [],
                pageSize: 10,
                searchList: [],
                list: Cookies.get('type') === '0' ? [
                    {title: '公益组织保险', type: 1, page: 0, finished: false, loading: false, list: []},
                    {title: '公益人保险', type: 2, page: 0, finished: false, loading: false, list: []},
                    {title: '特殊人群保险', type: 3, page: 0, finished: false, loading: false, list: []},
                    {title: '公益人体检', type: 5, page: 0, finished: false, loading: false, list: []},
                    /*{title: '咨询', type: 4, page: 0, finished: false, loading: false, list: []},*/
                ] : [
                    {title: '推荐', type: 1, page: 0, finished: false, loading: false, list: []},
                    {title: '短期险', type: 2, page: 0, finished: false, loading: false, list: []},
                    {title: '长期险', type: 3, page: 0, finished: false, loading: false, list: []},
                    {title: '咨询', type: 4, page: 0, finished: false, loading: false, list: []},
                    {title: '理赔', type: 5, page: 0, finished: false, loading: false, list: []},
                ],
            }
        },
        created() {
            this.getBannerImage()
            this.getHotArticle()
        },
        methods: {
            role() {
                return this.$store.state.user.role ? this.$store.state.user.role : '0'
            },
            gotoArticleDetail(item) {
                if (item.newsUrl.length > 0) {
                    window.location.href = item.newsUrl
                } else {
                    // this.$router.push({path: '/articleDetail', query: {newsId: item.newsId}})
                    window.location.href = `${process.env.VUE_APP_SHARE_URL}/articleDetail?newsId=${item.newsId}`
                }
            },
            getBannerImage() {
                this.$axios.get("/image/shuffling", {params: {imageType: '5', imageBelong: this.type}}).then(res => {
                    this.images = res.data;
                });
            },
            getHotArticle() {
                this.$axios.get("/article/list", {params: {type: '7', newsBelong: this.type}}).then(res => {
                    this.hots = res.data.rows;
                });
            },
            getAritcleList() {
                const item = this.list[this.active]
                if (item.finished) {
                    return
                }
                item.page++;
                item.loading = true;
                this.$axios.get("/article/list", {
                    params: {
                        type: '5',
                        page: item.page,
                        pageSize: this.pageSize,
                        category: item.type,
                        newsBelong: this.type
                    }
                }).then(res => {
                    item.loading = false;
                    let data = res.data.rows;
                    item.list = item.list.concat(data);
                    if (data.length < this.pageSize) {
                        item.finished = true;
                    }
                }).catch(err => {
                    item.loading = false
                })
            },
            search(text) {
                this.$axios.get("/article/fuzzyFind", {params: {newsTitle: text}}).then(res => {
                    this.searchList = res.data;
                });
            }
        }
    }
</script>

<style scoped>
    .discoverContent {
        display: flex;
        flex-direction: column;
        align-items: center;
        background-color: white;
        position: relative;
    }

    .line {
        border-top: #F3F3F3 10px solid;
        width: 100%;
    }

    .van-search__content {
        background-color: rgba(247, 248, 250, 0.7);
    }

</style>
